
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import { Dialog } from 'vant'

import { resolveMediaUrl } from '@/utils/mediaUrl'

export default {
components: {
Checker,
CheckerItem,
Grid,
GridItem
},
data () {
return {
tabIndex: 0,
titleList: [],
demo2: '小学',
gradelableList: [],
gradeTableList: [],
calssList: [],
calssState: false,
showCompactBar: false,
filterPanelShow: false,
scrollContainer: null,
filterThreshold: 100
}
},
computed: {
showBackNav () {
return this.$route.path === '/wordIndex_displa' || this.$route.query.selectBook === '1' || this.$route.query.selectBook === 1
},
currentSchoolName () {
const item = this.titleList[this.tabIndex]
return item ? item.categoryName : ''
},
currentVersionName () {
const item = this.gradelableList.find(i => i.value === this.calssList)
return item ? item.label : ''
}
},
created () {
this.recwordCateFirst()
},
mounted () {
this.$nextTick(() => {
this.initScrollListener()
})
},
beforeDestroy () {
if (this.scrollContainer) {
this.scrollContainer.removeEventListener('scroll', this.onPageScroll)
}
window.removeEventListener('resize', this.updateFilterThreshold)
},
watch: {
tabIndex (val) {
if (this.titleList[val]) {
this.selectBookCategory(this.titleList[val])
}
},
calssList (val, oldVal) {
if (!this.calssState) return
if (val !== '' && val !== oldVal) {
this.loadBooksByClass(val)
}
}
},
methods: {
goBack () {
if (window.history.length > 1) {
this.$router.back()
} else {
this.$router.push({ path: '/home', query: { hideTrans: 'true' } })
}
},
initScrollListener () {
this.scrollContainer = this.getScrollContainer()
this.updateFilterThreshold()
window.addEventListener('resize', this.updateFilterThreshold)
if (this.scrollContainer) {
this.scrollContainer.addEventListener('scroll', this.onPageScroll, { passive: true })
this.onPageScroll()
}
},
getScrollContainer () {
const viewBoxBody = document.getElementById('vux_view_box_body')
if (viewBoxBody) return viewBoxBody
let el = this.$el.parentElement
while (el && el !== document.body) {
const style = window.getComputedStyle(el)
if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
return el
}
el = el.parentElement
}
return window
},
updateFilterThreshold () {
this.$nextTick(() => {
const block = this.$refs.filterBlock
if (block) {
this.filterThreshold = block.offsetHeight - 20
}
})
},
onPageScroll () {
const scrollTop = this.scrollContainer === window
? (window.pageYOffset || document.documentElement.scrollTop)
: this.scrollContainer.scrollTop
this.showCompactBar = scrollTop > this.filterThreshold
},
openFilterPanel () {
this.filterPanelShow = true
},
closeFilterPanel () {
this.filterPanelShow = false
},
recwordCateFirst () {
this.$ajax.post(this.$api.recwordCateFirst).then(result => {
this.titleList = result || []
if (this.titleList.length > 0) {
this.selectBookCategory(this.titleList[0])
}
})
},
selectBookCategory (titleInfo) {
this.calssState = false
this.calssList = []
this.gradeTableList = []

this.$ajax
.get(this.$api.selectBookTreeBCateGoryId + '?id=' + titleInfo.categoryId)
.then(result => {
this.gradelableList = result || []
if (this.gradelableList.length > 0) {
this.calssList = this.gradelableList[0].value
this.loadBooksByClass(this.calssList)
}
this.calssState = true
this.$nextTick(() => {
this.updateFilterThreshold()
})
})
},
loadBooksByClass (classValue) {
if (classValue === '' || classValue == null) return
const classList = Array.isArray(classValue) ? classValue : [classValue]
this.$ajax
.post(this.$api.selectBookAllByclass, { classList })
.then(result => {
this.gradeTableList = this.normalizeBookList(result || [])
})
},
normalizeBookList (list) {
return list.map(obj => {
const item = { ...obj }
if (item.img != null && item.img.indexOf('http') !== 0) {
item.img = resolveMediaUrl(item.img)
}
return item
})
},
splitLabel (label) {
if (!label) {
return { line1: '', line2: '' }
}
const idx = label.indexOf('）')
if (idx !== -1) {
return {
line1: label.substring(0, idx + 1),
line2: label.substring(idx + 1)
}
}
if (label.length > 6) {
return {
line1: label.substring(0, 6),
line2: label.substring(6)
}
}
return { line1: label, line2: '' }
},
gotoPmsCellListByBookId (bookID) {
if (this.$route.query.selectBook) {
Dialog.confirm({
title: '确定添加该书本进行学习嘛？',
message: ''
})
.then(() => {
this.$ajax
.post(this.$api.setUserInfo, { key: 'studyBookID', value: bookID.value })
.then(() => {
this.$router.push({ path: '/home?hideTrans=true' })
})
})
.catch(() => {})
return false
}
this.$router.push({ path: '/pmsCellList_display', query: bookID })
}
}
}



// WEBPACK FOOTER //
// ./src/views/word/wordIndex.vue